import React from 'react';
import { MetaPixel } from '../components/MetaPixel';
import { ClarityScript } from '../components/ClarityScript';
import { Hero } from '../components/Hero';
import { ValidatorsBar } from '../components/ValidatorsBar';
import { ProblemAgitation } from '../components/ProblemAgitation';
import { ProductTransformation } from '../components/ProductTransformation';
import { BonusSection } from '../components/BonusSection';
import { Authority } from '../components/Authority';
import { Testimonials } from '../components/Testimonials';
import { ValueStack } from '../components/ValueStack';
import { Guarantee } from '../components/Guarantee';
import { FAQ } from '../components/FAQ';
import { FinalUrgency } from '../components/FinalUrgency';
import { StickyMobileCTA } from '../components/StickyMobileCTA';
import { PurchaseNotification } from '../components/PurchaseNotification';
export function LandingPage() {
  return <div className="min-h-screen bg-white font-sans text-slate-800" data-id="element-339">
      <MetaPixel data-id="element-340" />
      <ClarityScript data-id="element-341" />

      <main data-id="element-342">
        <Hero data-id="element-343" />
        <ValidatorsBar data-id="element-344" />
        <ProblemAgitation data-id="element-345" />
        <ProductTransformation data-id="element-346" />
        <BonusSection data-id="element-347" />
        <Authority data-id="element-348" />
        <Testimonials data-id="element-349" />
        <ValueStack data-id="element-350" />
        <Guarantee data-id="element-351" />
        <FAQ data-id="element-352" />
        <FinalUrgency data-id="element-353" />
      </main>

      <footer className="bg-secondary text-gray-500 py-8 text-center text-xs" data-id="element-354">
        <div className="max-w-7xl mx-auto px-4" data-id="element-355">
          <p className="mb-2" data-id="element-356">
            © {new Date().getFullYear()} Adiós al Azúcar. Todos los derechos
            reservados.
          </p>
          <p data-id="element-357">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio no está respaldado por Facebook de ninguna
            manera.
          </p>
        </div>
      </footer>

      {/* Overlays */}
      <StickyMobileCTA data-id="element-358" />
      <PurchaseNotification data-id="element-359" />
    </div>;
}